export default __webpack_public_path__ + "4f9935c549470c5524d3f741e337a111.png";